import { Grid } from "@cd2/components/build/es6"
import { Form2 } from "@cd2/forms/build/es6"
import { useForm } from "@cd2/forms/build/es6/Form2"
import React from "react"
import { autoCompleteOff } from "../constants/autoComplete"

import { IPostcodeLookupReturnValue, PostcodeField } from "./Pages/CustomerShowPage/PostcodeField"
import { CountrySelect } from "./SelectLists/CountrySelect"
import { Form2ValidatePostcodeLength } from "../utils/Form2ValidatePostcodeLength"

AddressFormFields.getAddressFields = (prefix: string) =>
  [
    "name",
    "line_1",
    "line_2",
    "line_3",
    "line_4",
    "city",
    "county",
    "country",
    "postcode",
    "phone",
    "email",
  ].map(field => ({ prefixed: `${prefix}${field}`, field }))
export function AddressFormFields({
  fieldPrefix = "",
}: {
  fieldPrefix?: "shipping_address" | "billing_address" | string
}) {
  const form = useForm()
  function handlePostcodeSelect(value: IPostcodeLookupReturnValue) {
    if (!form) {
      throw new Error("No address form")
    }

    form.setPartialData({
      [`${fieldPrefix}city`]: value.city,
      [`${fieldPrefix}country`]: value.country,
      [`${fieldPrefix}county`]: value.county,
      [`${fieldPrefix}line_1`]: value.line_1,
      [`${fieldPrefix}line_2`]: value.line_2,
      [`${fieldPrefix}line_3`]: value.line_3,
      [`${fieldPrefix}name`]: value.name,
      [`${fieldPrefix}postcode`]: value.postcode,
    })
  }

  Form2.useFormSubmitLock(() => {
    const postcodeField = form.getField(`${fieldPrefix}postcode`)
    const value = postcodeField.getValue()
    if (!value) {
      postcodeField.setError("must be present")
      return false
    } else {
      postcodeField.setError(undefined)
    }
  })

  return (
    <Grid gap={8}>
      <Form2.Text
        field={`${fieldPrefix}name`}
        placeholder="Name"
        label="Name"
        autoComplete={autoCompleteOff}
        validations={{ presence: true }}
      />

      <Grid columns={{ repeat: { times: "auto-fit", size: { min: 160, max: { fr: 1 } } } }} gap={8}>
        <Form2.Text
          field={`${fieldPrefix}line_1`}
          placeholder="Line 1"
          label="Line 1"
          autoComplete={autoCompleteOff}
          validations={{ presence: true }}
        />
        <Form2.Text
          field={`${fieldPrefix}line_2`}
          placeholder="Line 2"
          label="Line 2"
          autoComplete={autoCompleteOff}
        />
      </Grid>
      <Grid columns={{ repeat: { times: "auto-fit", size: { min: 160, max: { fr: 1 } } } }} gap={8}>
        <Form2.Text
          field={`${fieldPrefix}line_3`}
          placeholder="Line 3"
          label="Line 3"
          autoComplete={autoCompleteOff}
        />
        <Form2.Text
          field={`${fieldPrefix}line_4`}
          placeholder="Line 4"
          label="Line 4"
          autoComplete={autoCompleteOff}
        />
      </Grid>
      <Form2.Text
        field={`${fieldPrefix}city`}
        placeholder="City"
        label="City"
        autoComplete={autoCompleteOff}
      />
      <Grid columns={{ repeat: { times: "auto-fit", size: { min: 160, max: { fr: 1 } } } }} gap={8}>
        <Form2.Text
          field={`${fieldPrefix}county`}
          placeholder="County"
          label="County"
          autoComplete={autoCompleteOff}
        />
        <Form2.WithField
          field={`${fieldPrefix}postcode`}
          render={field => (
            <PostcodeField
              label={
                <Form2.FieldLabel fieldName={`${fieldPrefix}postcode`} label="Postcode" required />
              }
              onPostcodeSelect={handlePostcodeSelect}
              postcodeFieldError={field.getError()}
            />
          )}
          subscribe
        />
        <Form2ValidatePostcodeLength field="postcode" />
      </Grid>
      <CountrySelect />
      <Form2.Phone field={`${fieldPrefix}phone`} placeholder="Phone" label="Phone" />
      <Form2.Email
        field={`${fieldPrefix}email`}
        placeholder="Email"
        label="Email"
        autoComplete={autoCompleteOff}
      />
    </Grid>
  )
}
